import React from 'react';

import { IRouter } from '@routers/interface';

export const routerLogin: IRouter = {
  path: '/',
  loader: React.lazy(() => import('./index')),
  exact: true,
  masterLayout: false,
};
